export default {
  metaDescription: 'PT Tokki Engineering and Fabrication(TEF)へのお問い合わせ。チカラン、チレゴン、グレシック、メダンの各拠点まで営業・お問い合わせはこちら。',
  pageTitle: 'お問い合わせ',
  offices: {
    discovery: { label: 'チカラン工場・オフィス' },
    endeavor: { label: 'チレゴン工場・オフィス' },
    voyager: { label: 'グレシック支店' },
    frontier: { label: 'メダン駐在員事務所' },
  },
  salesTeam: {
    talkToOur: 'お問い合わせは',
    salesTeam: '営業チームまで',
    description: '以下のフォームにご記入ください。担当チームより迅速にご連絡し、お客様の特別なプロジェクトのご要望にお応えいたします。',
  },
  form: {
    name: 'お名前',
    companyName: '会社名',
    email: 'メールアドレス',
    phoneNumber: '電話番号',
    message: 'メッセージ',
    send: '送信',
    pleaseWait: 'お待ちください...',
  },
};
